import request from './request';

//图文详情接口
//获取图文详情
export function getTextDetailList (params) {
  return request({
    url: 'api.php?m=lesson.getInfoByID&v=1.x',
    method: 'post',
    data: params || {}
  })
}
// 相关阅读
export function getReadList (params) {
  return request({
    url: 'api.php?m=lesson.getListByIDs&v=1.x',
    method: 'post',
    data: params || {}
  })
}
// 相关课程
export function getRelCourList (params) {
  return request({
    url: 'api.php?m=lesson.getListByIDs&v=1.x',
    method: 'post',
    data: params || {}
  })
}
